import {
  applyConfirmRoundResult,
  applyReadyForPriceSubmission,
  applyRevealRound,
  applyStartExtensionRound,
  applySubmitPrices,
  applyUseChange,
  applyUseSecret,
} from "./appliers";
import type { FruitShopV2Action, FruitShopV2State } from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: FruitShopV2State,
  action: FruitShopV2Action,
): FruitShopV2State {
  if (!validateAction(state, action).valid) {
    return state;
  }

  if (action.type === "ReadyForPriceSubmission") {
    return applyReadyForPriceSubmission(state, action);
  }
  if (action.type === "SubmitPrices") {
    return applySubmitPrices(state, action);
  }
  if (action.type === "UseSecret") {
    return applyUseSecret(state, action);
  }
  if (action.type === "UseChange") {
    return applyUseChange(state, action);
  }
  if (action.type === "RevealRound") {
    return applyRevealRound(state, action);
  }
  if (action.type === "ConfirmRoundResult") {
    return applyConfirmRoundResult(state, action);
  }
  if (action.type === "StartExtensionRound") {
    return applyStartExtensionRound(state, action);
  }

  return state;
}
